import Requester from "./Requester";
// import jwtDecode from 'jwt-decode';
import dayjs from 'dayjs';

export function login(data) {
    const requester = new Requester();

    return requester.post(requester.getUrl(`api/login`), data)
}

export function me() {
    const requester = new Requester();

    return requester.get(requester.getUrl(`api/me`))
}



export function setToken(token, expires) {
    localStorage.setItem('token', token);
    localStorage.setItem("token_exp", expires);
}


export function getToken() {
    return localStorage.getItem("token");
}

export function clearToken() {
    localStorage.removeItem("token");
    localStorage.removeItem("token_exp");
}

export function setTokenExp(exp) {
    localStorage.setItem("token_exp", exp);
}
export function getTokenExp() {
    const value = localStorage.getItem("token_exp");

    return value ? parseInt(value) : 0;
}

export function checkAuth() {
    if (getToken() === null) {
        return false;
    } else if (getTokenExp() !== null) {
        let date = dayjs();
        let now = date.unix();
        if (getTokenExp() - now > 0) {
            return true
        } else {
            clearToken();
            return false;
        }
    } else {
        return true
    }
}

export function logout() {
    localStorage.removeItem("token");
    localStorage.removeItem("token_exp");
    window.location.reload();
}


export default {
    login,
    setToken,
    getToken,
    clearToken,
    checkAuth,
    logout,
    me
}